
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'

enum EumLoadStatus {
  Success = 'success',
  Fail = 'fail'
}

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class RealImg extends Vue {
  @Prop({ required: true, default: () => [] }) realUrlList: Array<{
    url: string | null
    key: string
  }>
  @Prop({ required: true }) imageSize: { width: number; height: number; originWidth: number; originHeight: number }
  @Prop({ required: true }) group: number

  @Ref()
  realImg!: HTMLDivElement

  status: EumLoadStatus[] = []
  ob: IntersectionObserver | null = null
  firstLoaded: boolean = true

  get realImgStyle() {
    const styles: Array<string> = []

    const { width, height } = this.imageSize

    styles.push(`width: ${this.$px2rem(width)}`)
    styles.push(`height: ${this.$px2rem(height)}`)

    return styles.join(';')
  }

  onLoadImg(idx: number) {
    this.status[idx] = EumLoadStatus.Success
  }

  created(): void {}

  mounted(): void {
    this.ob = new IntersectionObserver(
      entity => {
        // 跳过初始化首组第一次重复触发
        if (this.group === 0) {
          this.firstLoaded = false
        }

        if (!this.firstLoaded) {
          this.firstLoaded = true
          return
        }

        if (entity[0].isIntersecting) {
          this.$emit('pre-load')
        }
      },
      {
        root: null,
        threshold: [0, 1]
      }
    )

    this.ob.observe(this.realImg)
  }

  updated(): void {}

  destroyed(): void {
    if (this.ob) {
      this.ob.disconnect()
    }
  }
}
